import { specificationService } from '@/shared/services/api/specification-service';
import { ISpecificationCategoryResponse } from '@/shared/services/interface/responses/ISpecificationResponse';
import { IProductCategoryExploreResponse } from '@/shared/services/interface/responses/ISpecificationResponses';
import { IGetProductCategoriesRequest } from '@/shared/services/interface/requests/specification';
import { createAsyncThunk } from '@reduxjs/toolkit';

export interface IGetSpecificationResponse {
    specification: any;
    categories: ISpecificationCategoryResponse[];
}

export const getSpecificationThunk = createAsyncThunk(
    'specification/getSpecification',
    async (
        payload: {
            specificationId: string;
            companyId: string;
            userId?: string;
            folderId?: string;
        },
        thunkAPI
    ) => {
        try {
            const returnResponse: IGetSpecificationResponse = {
                specification: null,
                categories: [],
            };
            const specificationResponse =
                await specificationService.getSpecification({
                    companyId: payload.companyId,
                    specificationId: payload.specificationId,
                });

            if (specificationResponse.success) {
                const specificationDetail = specificationResponse.data as any;
                returnResponse.specification = specificationDetail;
                const specificationCategoryResponse =
                    await specificationService.getSpecificationCategoryAndItem({
                        userId: payload.userId || undefined,
                        companyId: specificationDetail.company.id,
                        specificationId: specificationDetail.id,
                    });
                if (specificationCategoryResponse.success) {
                    // ⚠️ ROOT CAUSE FIX: Parse new API response format
                    const apiData = specificationCategoryResponse.data;
                    if (apiData && Array.isArray(apiData)) {
                        // Use API response directly (no parsing needed)
                        returnResponse.categories = apiData.filter((item) => item.type === "category") as ISpecificationCategoryResponse[];
                    } else {
                        returnResponse.categories = [];
                    }
                }
            }
            return returnResponse;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getCategoryAndItemThunk = createAsyncThunk(
    'specification/getCategoryAndItem',
    async (
        payload: {
            specificationId: string;
            companyId: string;
            search?: string | null;
            categoryIds?: string[] | null;
            userId?: string | undefined;
        },
        thunkAPI
    ) => {
        try {
            const response =
                await specificationService.getSpecificationCategoryAndItem(
                    payload
                );
            
            // Use API response directly (no parsing needed)
            const apiData = response.data;

            if (apiData && Array.isArray(apiData)) {
                // Filter only categories for top-level (items are children of categories)
                return apiData.filter((item) => item.type === "category") as ISpecificationCategoryResponse[];
            }
            
            // Fallback: return empty array if no data
            return [];
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getProductCategoriesThunk = createAsyncThunk(
    'specification/getProductCategories',
    async (payload: IGetProductCategoriesRequest, thunkAPI) => {
        try {
            const response = await specificationService.getProductCategories(payload);
            return response.data as IProductCategoryExploreResponse;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
